const ORIGINS = new Map([
  { key: 'file-origin-web', value: 'Web' },
  { key: 'file-origin-system', value: 'System' },
  { key: 'file-origin-ios', value: 'iOS' },
  { key: 'file-origin-android', value: 'Android' },
  { key: 'getmyinvoices.com', value: 'Extern' },
].map(obj => [obj.key, obj.value]))

export const fileOriginToDisplayName = (originKey) => {
  const label = ORIGINS.get(originKey)
  return label || originKey
}
